import * as React from "react";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {a11yProps} from "../../../../tabPanel/functionHelpers";
import {TabPanel} from "../../../../tabPanel/tabPanel";
import {FilterContentByData} from "../filterContent/filterContentByData";
import {setTaskListFilterParams} from "../../../../../business/redux/reducers/filter/actions";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

export const FilterTabs = () => {

    const {taskListFilterData} = useSelector(s => s.taskReducer);

    const {taskListFilterParams} = useSelector(s => s.filters);

    const accountManagerNames = (taskListFilterData?.accountManagers || []).map(el => ({value: el.id, label: el.name}))
    const createdBy = (taskListFilterData?.created_by || []).map(el => ({value: el.name, label: el.name}))
    const taskNames = (taskListFilterData?.taskNames || []).map(el => ({value: el.id, label: el.task_name}))
    const moveTypes = (taskListFilterData?.moveTypes || [] || []).map(el => ({value: el, label: el}))

    const initialTaskListFilter = [
        {
            fieldName: "mcName",
            displayField: "MC name",
            type: "checkbox",
            fields: accountManagerNames
        },
        {
            fieldName: "date",
            displayField: "Date",
            type: "date_range",
        },
        {
            fieldName: "taskName",
            displayField: "Task Name",
            type: "checkbox",
            // searchable: true,
            fields: taskNames
        },
        {
            fieldName: "dueDate",
            displayField: "Due Date",
            type: "date_range",
        },
        {
            fieldName: "jobDate",
            displayField: "Job Date",
            type: "date_range",
        },
        {
            fieldName: "Move Type",
            displayField: "Move Type",
            type: "checkbox",
            fields: moveTypes
        },
        {
            fieldName: 'Created By',
            displayField: 'Created By',
            type: "checkbox",
            fields: createdBy
        }
    ]

    const dispatch = useDispatch();

    const [value, setValue] = useState(0);

    const handleChange = (_, newValue) => setValue(newValue);

    const {filters} = useSelector(s => s);

    const {leadFilter, filterParams} = filters;

    return (
        <Box
            className="modal-description"
            sx={{flexGrow: 1, bgcolor: 'background.paper'}}
        >
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Filter Tab"
                className="Filter_Tab"
                indicatorColor="transparent"
                sx={{background: '#EBECF0', p: 2, minWidth: '320px'}}
            >
                {initialTaskListFilter.map((el, idx) => {

                        const data = {...filterParams};

                        if (Boolean(data[el.fieldName]) && Array.isArray(data[el.fieldName])) {
                            data[el.fieldName] = []
                        } else if (Boolean(data[el.fieldName]) && typeof data[el.fieldName] === "string") {
                            data[el.fieldName] = ''
                        } else {
                            delete data[el.fieldName];
                        }

                        delete data[`${el.fieldName}_from`];
                        delete data[`${el.fieldName}_to`];


                        const highlightOffIcon = Boolean(
                            (['checkbox', 'input'].includes(el.type) && leadFilter[el.fieldName]?.length) ||
                            (['date_range', 'number_range'].includes(el.type) && (leadFilter[`${el.fieldName}_from`] || leadFilter[`${el.fieldName}_to`]))
                        )

                        return (
                            <Tab
                                sx={{py: 0, px: 2, mb: 1}}
                                className="filter_tab_btn"
                                label={el.displayField}
                                icon={highlightOffIcon
                                    ? <HighlightOffIcon
                                        color={'error'}
                                        onClick={() => dispatch(setTaskListFilterParams(data))}
                                    />
                                    : <></>}
                                iconPosition={'end'}
                                {...a11yProps(idx)}
                            />
                        );
                    }
                )}
            </Tabs>

            {initialTaskListFilter?.map((el, idx) => (
                <TabPanel
                    key={idx}
                    value={value}
                    index={idx}
                >
                    <FilterContentByData
                        el={el}
                        key={idx}
                        filterParams={taskListFilterParams}
                        setFilterParams={setTaskListFilterParams}
                    />
                </TabPanel>
            ))}
        </Box>
    );
}
